import React, { useContext, useEffect, useState } from 'react';
import { ask__ } from './../../shared/utils/i18n.js';
import { getAppointments } from './../../shared/utils/api.js';
import { GlobalErrorContext } from './../../shared/context/GlobalErrorContext.js';
import { GlobalUserContext } from '../../shared/context/GlobalUserContext.js';
import { GlobalIsRegisteredContext } from '../../shared/context/GlobalIsRegistered.js';

import Icon from '../Icon/Icon';
import Loader from '../Loader/Loader';
import Timeslot from '../Timeslot/Timeslot';

import './Reservations.scss';

export default function Reservations(props) {

  const {setGlobalError} = useContext(GlobalErrorContext);
  const {getGlobalIsRegistered} = useContext(GlobalIsRegisteredContext);
  const {getGlobalUser} = useContext(GlobalUserContext);

  const [isReservationsLoading, setIsReservationsLoading] = useState(true);
  const [reservationsCacheBuster, setReservationsCacheBuster] = useState(Date.now());
  const [reservationsWasCancelled, setReservationsWasCancelled] = useState(false);
  const [reservationData, setReservationData] = useState(false);

  // reservations
  useEffect(() => {

    (async () => {

      setIsReservationsLoading(true);

      if (getGlobalUser.isLoggedIn && getGlobalIsRegistered) {

        try {

          const reservations = await getAppointments(props.type);
          setReservationData(reservations);

        } catch(err) {
          console.error(err);
          setGlobalError({
            isError: true,
            errorCode: 'PRE201'
          });
        }

      }

      setIsReservationsLoading(false);

    })();

  }, [reservationsCacheBuster, getGlobalIsRegistered, props]);

  return (
  <>

{getGlobalUser.isLoggedIn && getGlobalIsRegistered ? <>



  {isReservationsLoading ? <>

    <Loader align="left" />

  </> : <>

    <div className="reservations">

    <div className="reservations__terms" dangerouslySetInnerHTML={{__html: (window.ortonWebsiteData.i18n.cancel || '')}}></div>

      {reservationsWasCancelled ? <>
        <div className="reservations__notice">
          <div className="reservations__notice__icon">
            <Icon name="check-outline" />
          </div>
          <p>
            { ask__('Booking: Cancel complete') }
          </p>
        </div>
      </> : ''}

      {reservationData && reservationData.length ? <>

        <div className="reservations__list">

        {reservationData.map((t, i) => {
        return (
          <Timeslot
            key={i}
            type="reservation"
            timeStart={t.time_start}
            timeDay={t.time_day}
            timeHour={t.time_hour}
            timeType={t.type}
            duration={t.duration}
            unit={t.unit}
            resourcePath={t.resource}
            isVideoReception={t.is_video_reception}
            isPhoneReception={t.is_phone_reception}
            name={t.specialist.has_meta ? t.specialist.name : ''}
            title={t.specialist.has_meta ? t.specialist.title : ''}
            legal={t.specialist.has_meta ? t.specialist.legal : ''}
            image={t.specialist.has_meta ? t.specialist.img_url : ''}
            ninchatId={t.specialist.has_meta ? t.specialist.ninchat_id : ''}
            locationName={t.unit_name}
            locationAddress={t.unit_address}
            specialistUrl={t.specialist.has_meta ? t.specialist.specialist_url : ''}
            isCancelled={t.is_cancelled}
            canCancel={t.can_cancel}
            videoReceptionOpens={t.video_reception_opens_timestamp}
            videoReceptionCloses={t.video_reception_closes_timestamp}
            videoReceptionLink={t.video_reception_link}
            cancelText={t.cancel_text}
            reservationPath={t.reservation}
            onCancel={(e) => {
              setReservationsCacheBuster(Date.now());
              setReservationsWasCancelled(true);
            }}
          />
        )
      })}

        </div>

      </> : <>

        <p>{ ask__('Profile: No reservations') }</p>

      </>}

    </div>

  </>}

  </> : <></>}

  </>
  );


}
